import { Logtail } from "@logtail/browser";
import { sanitizeLogData } from '../config/security';

const logtailToken = import.meta.env.VITE_LOGTAIL_TOKEN;
const logtailEndpoint = import.meta.env.VITE_LOGTAIL_ENDPOINT as string | undefined;

export const logtail = logtailToken
  ? new Logtail(logtailToken, logtailEndpoint ? { endpoint: logtailEndpoint } : undefined)
  : null;

// Persisted user context to enrich all logs
let persistedUserContext: { uid?: string; email?: string | null } = {};

export function setLogUserContext(uid: string, email?: string | null) {
  persistedUserContext = { uid, email: email ?? null };
}

export function clearLogUserContext() {
  persistedUserContext = {};
}

function mergeContext(context?: Record<string, any>) {
  const merged = {
    ...(persistedUserContext.uid ? { uid: persistedUserContext.uid } : {}),
    ...(persistedUserContext.email ? { email: persistedUserContext.email } : {}),
    ...(context || {}),
  };
  
  // Sanitize sensitive data before logging
  return sanitizeLogData(merged);
}

export function logInfo(message: string, context?: Record<string, any>) {
  if (logtail) logtail.info(message, mergeContext(context));
}
export function logWarn(message: string, context?: Record<string, any>) {
  if (logtail) logtail.warn(message, mergeContext(context));
}
export function logError(message: string, context?: Record<string, any>) {
  if (logtail) logtail.error(message, mergeContext(context));
} 